import { YapuService } from '@/modules/global-settings/loan-origination/services/yapu.service';
import { make } from 'vuex-pathify';
import Logger from '@/lib/logger';
// Create a new service instance for the YapuService
const yapuService = new YapuService();
// Export module state
export const state = {
  climateRiskRatings: [],
  globalClimateRiskRatings: {},
  yapuManagementSettings: {}
};
// Export module mutations
export const mutations = {
  ...make.mutations(state)
};
// Export module actions
export const actions = {
  getClimateRiskRatings: async ({ commit }) => {
    try {
      const { data } = await yapuService.getClimateRiskRatings();
      commit('SET_CLIMATE_RISK_RATINGS', data);
      return data;
    } catch (error) {
      Logger.error('getting climate risk ratings', error);
      throw error;
    }
  },
  getGlobalClimateRiskRatings: async ({ commit }) => {
    try {
      const { data } = await yapuService.getGlobalClimateRiskRatings();
      commit('SET_GLOBAL_CLIMATE_RISK_RATINGS', data);
      return data;
    } catch (error) {
      Logger.error('getting global climate risk ratings', error);
      throw error;
    }
  },
  getYAPUManagementSettings: async ({ commit }) => {
    try {
      const { data } = await yapuService.getYAPUManagementSettings();
      commit('SET_YAPU_MANAGEMENT_SETTINGS', data[0]);
      return data[0];
    } catch (error) {
      Logger.error('getting yapu management settings', error);
      throw error;
    }
  },
  updateClimateRiskRating: async (_, obj) => {
    try {
      const { data } = await yapuService.updateClimateRiskRating(obj);
      return data;
    } catch (error) {
      Logger.error('updating climate risk rating', error);
      throw error;
    }
  },
  // action used to update global climate risk rating
  async updateGlobalClimateRiskRating(_, obj) {
    try {
      const res = await yapuService.updateGlobalClimateRiskRating(obj);
      return res;
    } catch (e) {
      Logger.error('updating global climate risk rating', e);
      throw e;
    }
  },
  async updateYAPUManagementSettings({ commit }, obj) {
    try {
      const { data } = await yapuService.updateYAPUManagementSettings(obj);
      commit('SET_YAPU_MANAGEMENT_SETTINGS', data);
      return data;
    } catch (e) {
      Logger.error('updating yapu management settings', e);
      throw e;
    }
  },

  findGlobalClimateRiskRating(value, { veryLow, low, middle, high }) {
    const v = Number(value);

    let rating;
    if (v <= Number(veryLow)) {
      rating = 'Very Low';
    } else if (v <= Number(low)) {
      rating = 'Low';
    } else if (v <= Number(middle)) {
      rating = 'Middle';
    } else if (v <= Number(high)) {
      rating = 'High';
    } else {
      rating = 'Very High';
    }
    return rating;
  }
};
// Export module getters
export const getters = {
  ...make.getters(state)
};
